/* eslint-disable no-undef */
import React, { Component }  from 'react' 
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// import { CKEditor } from 'ckeditor4-react'
import {
  getNoticeList,
  onUpdateList
} from '../../redux/notice/action'
import styles from './Notice.module.scss'
import { toast } from 'react-toastify'  
import {
  Row,
  Col,
  Checkbox,
  Button, 
  Input,
  message
} from 'antd' 
import QuillEditor from '../QuillEditor'
class FirstNotice extends Component {
  constructor(props){
    super(props)
    this.state = { 
      isBroadcast: false,
      text: '',
      times: '', 
      noticeItem: {},
      checkClick: false,  
      edited: false,
      ready: false
    }
  } 
  
  componentDidMount = async() => {
    if(typeof(localStorage.getItem('isBroadcast1')) === 'string' || typeof(localStorage.getItem('text1')) === 'string' || typeof(localStorage.getItem('times1')) === 'string') { 
      this.setState({
        isBroadcast: localStorage.getItem('isBroadcast1') === 'true' ? true : false,
        text: localStorage.getItem('text1'),
        times: localStorage.getItem('times1'), 
      })
    } 
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.noticeItem && this.state.ready && !this.state.edited) {
      // CKEDITOR.instances['firstnotice'].setData(this.props.noticeItem.text)
      this.setState({
        edited: true,
        text: this.props.noticeItem.text,
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProp) => {
    if(this.props.noticeItem !== nextProp.noticeItem){ 
      localStorage.setItem('isBroadcast1',nextProp.noticeItem.isBroadcast)
      localStorage.setItem('text1',nextProp.noticeItem.text)
      localStorage.setItem('times1',nextProp.noticeItem.times)
      this.setState({
        isBroadcast: nextProp.noticeItem.isBroadcast,
        text: nextProp.noticeItem.text,
        times: nextProp.noticeItem.times, 
      }) 
    }
  }
   
  textNotice = (e) => { 
    this.setState({
      text: e.editor.getData()
    }) 
    localStorage.setItem('text1',e.editor.getData())
  }
  quillTextNotice = (e) => {
    this.setState({
      text: e
    })
    localStorage.setItem('text1',e)
  }
  checkNotice = (e) => {  
    this.setState({
      isBroadcast: e.target.checked
    })
  }
  timesNotice = (e) => { 
    this.setState({
      times: e.target.value
    })
  }
  saveNotice = async() => {
    const { text,isBroadcast,times } = this.state
    const { onUpdateList,onLoading,offLoading,noticeItem } = this.props
    let data = {
      isBroadcast: isBroadcast,
      text: text,
      times: times, 
    }
    onLoading()
    await onUpdateList(noticeItem.id,data)
    // await fetchNotice()
    offLoading()
    message.success('บันทึกสำเร็จ')
  }
  options = {
    position: 'top-center',
    autoClose: false,
    hideProgressBar: false, 
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false, 
    className:'notice_alert notice_alert_first',
    toastClassName : 'notice_alert_toast',
    bodyClassName: 'notice_alert_body ',
    style: {position: 'absolute'}
  }
  onClickTestAlert = () => {  
    // const { noticeItem } = this.props  
    const { text } = this.state
    this.setState({ checkClick: true})
    toast( <div style={{paddingTop: '7px'}} dangerouslySetInnerHTML={{ __html: text }}/>,this.options ) 
  } 
  render(){  
    let  { isBroadcast, text, times } = this.state  
    const { noticeItem } = this.props     
    console.log('text', text)
    return (
      <div style={{ paddingBottom: '42px'}}> 
        <Row justify='center'>
          <Col span={1}  align='middle'>
            <span>{noticeItem ? noticeItem.id : ''}.</span>
          </Col>
          <Col span={1} >
            <Checkbox checked={ isBroadcast } onChange={ e => { e.stopPropagation(); this.checkNotice(e)} }/>
          </Col>
          <Col span={12} align='left'> 
            <Row>
              {
                (text === '' || text) && <QuillEditor 
                  value={text} 
                  height='134px'
                  onChange={e => { 
                    this.quillTextNotice(e)
                  }} 
                  onReady={e => {
                    this.setState({ready: true})
                  }}
                />
              }
              {/* {
                (text === '' || text) &&  <CKEditor  
                  initialData = { text  }
                  name="firstnotice"
                  onBeforeLoad={(CKEDITOR )=>(CKEDITOR.disableAutoInline = true)} 
                  onInstanceReady={(e) => {this.setState({ready: true})}}
                  config={{
                    height: '134px',
                    toolbarGroups : [
                      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                      { name: 'links', groups: [ 'links' ] },
                      { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                      { name: 'paragraph', groups: [ 'align', 'list', 'indent', 'blocks', 'bidi', 'paragraph' ] },
                      { name: 'insert', groups: [ 'insert' ] },
                      { name: 'document', groups: [ 'document', 'mode', 'doctools' ] },
                      { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                      { name: 'forms', groups: [ 'forms' ] },
                      '/',
                      '/',
                      { name: 'styles', groups: [ 'styles' ] },
                      { name: 'colors', groups: [ 'colors' ] },
                      { name: 'tools', groups: [ 'tools' ] },
                      { name: 'others', groups: [ 'others' ] },
                      { name: 'about', groups: [ 'about' ] }
                    ],
                    removeButtons : 'Source,Save,About,NewPage,Preview,Print,Templates,Maximize,ShowBlocks,BGColor,TextColor,Styles,Format,Font,FontSize,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,Unlink,Anchor,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Outdent,Indent,CreateDiv,Blockquote,BidiLtr,BidiRtl,Language,CopyFormatting,RemoveFormat,Cut',
                    imageUploadUrl: 'https://exam.sobtid.me/admin/questions/image', 
                    uploadUrl: 'https://exam.sobtid.me/admin/questions/image?responseType=json', 
                    filebrowserUploadUrl: 'https://exam.sobtid.me/admin/questions/imagefile?responseType=json',
                    editorUrl: 'https://cdn.ckeditor.com/4.25.1-lts/full/ckeditor.js',
                    extraPlugins: 'justify'
                  }} 
                  onChange = {e => { 
                    this.textNotice(e)
                  }}
                />  
              } */}
             
            </Row> 
            {/* <Row className={styles.textNotice_input} >
              <div onClick={e => {e.stopPropagation();this.onClickTestAlert()}} style={{background: '#FBD36B', cursor: 'pointer'}}>
                <p >ตัวอย่างข้อความประกาศ</p>
              </div> 
            </Row>  */}
          </Col>
          <Col span={2} offset={1} align='middle'>
            <Input value={ times } onChange={ e => {
              this.timesNotice(e)
            } } style={{ width: '80px'}} type='number'/>
          </Col>
          <Col span={4} align='middle'>
            <Button className={styles.button_save_notice} onClick={e => { e.stopPropagation();this.saveNotice() }  } type='primary'>บันทึก</Button>
            <div style={{ paddingTop: '10px' }}>
              <Button className={styles.button_save_notice} onClick={e => {e.stopPropagation();this.onClickTestAlert() }}>ดูตัวอย่าง</Button>
            </div> 
          </Col> 
        </Row>   
        {/* <NoticeAlert type = 'first' />  */}
      </div>
    )
  }
} 
const mapStateToProps = () => {
  return {   
    
  }
}
const mapDispatchToProps = dispatch => 
  bindActionCreators(
    {  
      getNoticeList,
      onUpdateList
    },
    dispatch
  )
// CKEditor.editorUrl = 'https://cdn.ckeditor.com/4.13.0/full/ckeditor.js'
export default connect(mapStateToProps,mapDispatchToProps)(FirstNotice) 